import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import powerslap from "./video/55.mp4";


const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  direction: rtl;
`;

const Video = styled.video`
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  height:100%;
  transform:translate(-50%,-50%);
  object-fit:cover;

  pointer-events:none;

  background:black;
pointer-events:none;
user-select:none;
-webkit-user-select:none;
  &::-webkit-media-controls,
  &::-webkit-media-controls-panel,
  &::-webkit-media-controls-start-playback-button{
    display:none !important;
    -webkit-appearance:none;
  }
`;


const Overlay = styled.div`
  position:absolute;
  inset:0;

  background:
  linear-gradient(
    90deg,
    rgba(0,0,0,.75),
    rgba(0,0,0,.25)
  );

`;



const Content = styled.div`
  position:absolute;
  top:50%;
  right:8%;
  transform:translateY(-50%);

  max-width:650px;
  color:white;
  text-align:right;

  z-index:2;


  @media(max-width:768px){
    right:5%;
    left:5%;
    max-width:none;
    text-align:center;
  }

`;



const SmallTitle = styled.div`

font-size:32px;
font-weight:700;
margin-bottom:20px;
letter-spacing:1px;

@media(max-width:768px){
font-size:22px;
}

`;



const Title = styled.h1`

font-size:80px;
line-height:1.1;
font-weight:900;
margin:0;


span{
 color:#ff3030;

 text-shadow:
 0 0 20px rgba(255,0,0,.5);
}


@media(max-width:768px){

font-size:45px;

}

`;



const Text = styled.p`

font-size:22px;
line-height:1.8;
font-weight:500;

margin:35px 0;


@media(max-width:768px){
font-size:17px;
}

`;



const Buttons = styled.div`

display:flex;
gap:20px;
justify-content:flex-start;


button{

padding:16px 35px;
border-radius:3px;
font-size:18px;
font-weight:700;
cursor:pointer;

border:1px solid white;

background:transparent;
color:white;

transition:.3s;


&:hover{
transform:translateY(-3px);
}


}


button:first-child{

background:#ff3030;
border:none;

}



@media(max-width:768px){

justify-content:center;

button{
padding:12px 20px;
font-size:15px;
}

}

`;




function Screen(){
  const videoRef = useRef(null);

useEffect(() => {

  const video = videoRef.current;

  if(video){

    video.muted = true;

    video.load();

    video.play()
    .catch(() => {});

  }

}, []);
return(

<Wrapper id="home">


<Video
  ref={videoRef}
  autoPlay
  muted
  defaultMuted
  loop
  playsInline
  preload="auto"
  disablePictureInPicture
  controls={false}
  onCanPlay={() => {

    const video = videoRef.current;

    if(video){
      video.play().catch(() => {});
    }

  }}
>
  <source src={powerslap} type="video/mp4" />
</Video>


<Overlay/>


<Content>


<SmallTitle>
   

אוחנה
MMA

</SmallTitle>



<Title>

הגיע הזמן ללמוד

<br/>

<span>
אומנויות לחימה
</span>

</Title>



<Text>

10 שנים של פעילות<br/>
עשרות אלופים <br/>
מאות מתאמנים שנכנסו למשפחה  <br/>
ומועדון אחד שכולו לב ואהבה ללחימה

</Text>



<Buttons>

<button onClick={() => {
  document.getElementById("contact").scrollIntoView({
    behavior: "smooth"
  });
}}>
  🥊 להרשמה
</button>


<button onClick={() => {
  document.getElementById("Features").scrollIntoView({
    behavior: "smooth"
  });
}}>
   האימונים שלנו</button>

</Buttons>


</Content>


</Wrapper>

)

}


export default Screen;